import CompareControlIcon from "./assets/compare-control-icon.svg";
import CompareCostIcon from "./assets/compare-cost-icon.svg";
import hightlightBg from "./assets/compare-highlight-bg.png";
import CompareIcon from "./assets/compare-icon.svg";
import CompareTurnaroundIcon from "./assets/compare-turnaround-icon.svg";
import CompareWorkflowIcon from "./assets/compare-workflow-icon.svg";
import VidMuseLogo from "./assets/vidmuse-logo-icon.svg";

export function CompareTable() {
  return (
    <div className="w-full mt-20">
      {/* Header Section */}
      <div className="text-center">
        <h2 className="text-2xl font-bold text-white">
          Slash Production Costs by 99%.
        </h2>
        <p className="mt-2 text-xs text-white/40">
          Get your 24/7 private creative production house for the price of a
          lunch.
        </p>
      </div>

      {/* Scrollable Table Container */}
      <div className="w-full px-20 mt-7 py-2 text-white overflow-x-auto scrollContainer">
        <div className="w-[1280px] min-w-[1280px] mx-auto relative">
          {/* Horizontal divider lines - behind everything */}
          <div className="absolute inset-0 pointer-events-none">
            <div className="absolute left-0 right-0 h-px bg-[#24222d] top-[72px]" />
            <div className="absolute left-0 right-0 h-px bg-[#24222d] top-[144px]" />
            <div className="absolute left-0 right-0 h-px bg-[#24222d] top-[216px]" />
            <div className="absolute left-0 right-0 h-px bg-[#24222d] top-[314px]" />
            <div className="absolute left-0 right-0 h-px bg-[#24222d] top-[406px]" />
          </div>

          {/* 5x5 Grid Layout */}
          <div
            className="grid gap-0 relative"
            style={{
              gridTemplateColumns: "195px 248px 260px 263px auto",
              gridTemplateRows: "72px 72px 72px 98px 92px",
            }}
          >
            {/* Row 1, Col 1: Empty */}
            <div />

            {/* Row 1, Col 2: Empty (VidMuse card is absolutely positioned) */}
            <div />

            {/* Row 1, Col 3: Traditional Production */}
            <div className="flex items-center pl-[60px]">
              <p className="text-base font-bold text-white">
                Traditional Production
              </p>
            </div>

            {/* Row 1, Col 4: Freelancers */}
            <div className="flex items-center pl-[60px]">
              <p className="text-base font-bold text-white">
                Freelancer (Fiverr)
              </p>
            </div>

            {/* Row 1, Col 5: DIY AI Stack */}
            <div className="flex items-center pl-[60px]">
              <p className="text-base font-bold text-white">DIY AI Stack</p>
            </div>

            {/* Row 2, Col 1: Cost Label */}
            <div className="flex items-center gap-2 pl-7">
              <CompareCostIcon />
              <span className="text-sm font-medium text-white">Cost</span>
            </div>

            {/* Row 2, Col 2: Empty (VidMuse card is absolutely positioned) */}
            <div />

            {/* Row 2, Col 3: Traditional Production Cost */}
            <div className="flex items-center pl-[60px]">
              <p className="text-sm leading-none text-white">
                <span className="font-bold">$15K - 200K</span>
                <span className="text-white/40"> / project</span>
              </p>

              <span className="ml-1 flex items-center gap-0.5 py-[1.5px] px-1.5 bg-[#430009] text-[#FF8587] text-[11px] font-bold rounded-sm">
                <CompareIcon className="rotate-180" />
                <span>5128x</span>
              </span>
            </div>

            {/* Row 2, Col 4: Freelancers Cost */}
            <div className="flex items-center pl-[60px]">
              <p className="text-sm leading-none$100 text-white">
                <span className="font-bold">$100 - $300</span>
                <span className="text-white/40"> / min</span>
              </p>
              <span className="ml-1 flex items-center gap-0.5 py-[1.5px] px-1.5 bg-[#430009] text-[#FF8587] text-[11px] font-bold rounded-sm">
                <CompareIcon className="rotate-180" />
                <span>7.6x</span>
              </span>
            </div>

            {/* Row 2, Col 5: DIY AI Stack Cost */}
            <div className="flex items-center pl-[60px]">
              <p className="text-sm leading-none text-white">
                <span className="font-bold">$150</span>
                <span className="text-white/40"> / month</span>
              </p>

              <span className="ml-1 flex items-center gap-0.5 py-[1.5px] px-1.5 bg-[#430009] text-[#FF8587] text-[11px] font-bold rounded-sm">
                <CompareIcon className="rotate-180" />
                <span>3.8x</span>
              </span>
            </div>

            {/* Row 3, Col 1: Turnaround Label */}
            <div className="flex items-center gap-2 pl-7">
              <CompareTurnaroundIcon />
              <span className="text-sm font-medium text-white">Turnaround</span>
            </div>

            {/* Row 3, Col 2: Empty (VidMuse card is absolutely positioned) */}
            <div />

            {/* Row 3, Col 3: Traditional Production Turnaround */}
            <div className="flex items-center pl-[60px]">
              <p className="text-sm font-bold text-white">4 - 6 Weeks</p>
              <span className="ml-1 flex items-center gap-0.5 py-[1.5px] px-1.5 bg-[#430009] text-[#FF8587] text-[11px] font-bold rounded-sm">
                <CompareIcon className="rotate-180" />
                <span>480x</span>
              </span>
            </div>

            {/* Row 3, Col 4: Freelancers Turnaround */}
            <div className="flex items-center pl-[60px]">
              <p className="text-sm font-bold text-white">3 - 7 Days</p>
              <span className="ml-1 flex items-center gap-0.5 py-[1.5px] px-1.5 bg-[#430009] text-[#FF8587] text-[11px] font-bold rounded-sm">
                <CompareIcon className="rotate-180" />
                <span>112x</span>
              </span>
            </div>

            {/* Row 3, Col 5: DIY AI Stack Turnaround */}
            <div className="flex items-center pl-[60px]">
              <p className="text-sm font-bold text-white">2 - 3 Weeks</p>
              <span className="ml-1 flex items-center gap-0.5 py-[1.5px] px-1.5 bg-[#430009] text-[#FF8587] text-[11px] font-bold rounded-sm">
                <CompareIcon className="rotate-180" />
                <span>240x</span>
              </span>
            </div>

            {/* Row 4, Col 1: Workflow Label */}
            <div className="flex items-center gap-2 pl-7">
              <CompareWorkflowIcon />
              <span className="text-sm font-medium text-white">Workflow</span>
            </div>

            {/* Row 4, Col 2: Empty (VidMuse card is absolutely positioned) */}
            <div />

            {/* Row 4, Col 3: Traditional Production Workflow */}
            <div className="flex flex-col justify-start pt-3 pl-[60px]">
              <p className="text-sm font-bold text-white mb-[2px]">
                Heavy Logistics
              </p>
              <p className="text-xs text-white/40 leading-[17px]">
                Requires casting, location scouting and equipment rental etc.
              </p>
            </div>

            {/* Row 4, Col 4: Freelancers Workflow */}
            <div className="flex flex-col justify-start pt-3 pl-[60px]">
              <p className="text-sm font-bold text-white mb-[2px]">
                Managerial Friction
              </p>
              <p className="text-xs text-white/40 leading-[17px]">
                Back-and-forth communication and limited revisions
              </p>
            </div>

            {/* Row 4, Col 5: DIY AI Stack Workflow */}
            <div className="flex flex-col justify-center pl-[60px]">
              <p className="text-sm font-bold text-white mb-[2px]">
                Fragmented Chaos
              </p>
              <p className="text-xs text-white/40 leading-[17px]">
                Switching between apps, <br /> manually writing prompts and{" "}
                <br />
                editing
              </p>
            </div>

            {/* Row 5, Col 1: Control Label */}
            <div className="flex items-center gap-2 pl-7">
              <CompareControlIcon />
              <span className="text-sm font-medium text-white">Control</span>
            </div>

            {/* Row 5, Col 2: Empty (VidMuse card is absolutely positioned) */}
            <div />

            {/* Row 5, Col 3: Traditional Production Control */}
            <div className="flex flex-col pt-[18px] pl-[60px]">
              <p className="text-sm font-bold text-white mb-[2px]">Rigid</p>
              <p className="text-xs text-white/40 leading-5">
                Reshoots are expensive
              </p>
            </div>

            {/* Row 5, Col 4: Freelancers Control */}
            <div className="flex flex-col pt-[18px] pl-[60px]">
              <p className="text-sm font-bold text-white mb-[2px]">Limited</p>
              <p className="text-xs text-white/40 leading-[17px]">
                Extra revision costs more
              </p>
            </div>

            {/* Row 5, Col 5: DIY AI Stack Control */}
            <div className="flex flex-col pt-[18px] pl-[60px]">
              <p className="text-sm font-bold text-white mb-[2px]">
                Steep Learning Curve
              </p>
              <p className="text-xs text-white/40 leading-[17px]">
                Requires expert prompting <br /> and model knowledge
              </p>
            </div>
          </div>

          {/* VidMuse AI Agent Card - Absolute positioned to overlay */}
          <div
            className="absolute -top-[8px] -bottom-[8px] w-[248px] rounded-xl text-white font-bold pl-6"
            style={{
              left: "195px",
              background: `url(${hightlightBg.src}) center no-repeat`,
              backgroundSize: "cover",
            }}
          >
            {/* VidMuse Header */}
            <div className="flex gap-1 items-center h-20 text-base pt-1.5">
              <VidMuseLogo className="w-8 h-8" />
              <span>VidMuse AI Agent</span>
            </div>

            {/* Divider lines */}
            <div className="absolute left-6 right-6 top-[80px] h-px bg-white/5" />
            <div className="absolute left-6 right-6 top-[152px] h-px bg-white/5" />
            <div className="absolute left-6 right-6 top-[224px] h-px bg-white/5" />
            <div className="absolute left-6 right-6 top-[322px] h-px bg-white/5" />

            {/* Cost */}
            <div className="h-[72px] flex items-center text-sm">
              $39 / month
            </div>

            {/* Turnaround */}
            <div className="h-[72px] flex items-center text-sm">
              20 - 30 Minutes
            </div>

            {/* Workflow */}
            <div className="h-[99px] flex flex-col justify-start items-start text-sm pt-3">
              <p className="text-sm mb-0.5">Streamlined co-pilot</p>
              <p className="text-xs text-white/60 font-normal">
                You set the direction, VidMuse <br /> handles the grunt work
              </p>
            </div>

            {/* Control */}
            <div className="h-[92px] flex flex-col pt-[18px] items-start text-sm">
              <p className="text-sm mb-0.5">Iterative & Flexible</p>
              <p className="text-xs text-white/60 font-normal">
                Edit shots and export assets as <br /> you like
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
